import React from 'react';

export default function ({ children }) {
    return (
        <tbody className="p-datatable-tbody" data-pc-section="tbody">
            {children}
        </tbody>
    );
}
